module.exports = __webpack_public_path__ + "img/server-response-time.c56bc26.webp";